/**
 * followfood: Popout für Fangmethoden (snippets/ff-fishing-methods.liquid).
 *
 * Nutzt natives <dialog>: Escape-Taste, Focus-Trap und Backdrop kommen vom Browser.
 * Event-Delegation, weil das Snippet pro Produktseite mehrfach gerendert werden kann
 * (mehrere Custom-Liquid-Blöcke) — der Guard verhindert doppelte Listener, wenn das
 * Asset dadurch mehrfach eingebunden wird.
 *
 * Der Dialog wird über die Geschwister-Beziehung gefunden, nicht über IDs: bei
 * mehrfachem Rendern wären IDs nicht mehr eindeutig.
 */
(function () {
  if (window.ffFishingMethodsInit) return;
  window.ffFishingMethodsInit = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ff-fm-open]');
    if (trigger) {
      var dialog = trigger.parentElement.querySelector('.ff-fishing-method__dialog');
      if (dialog) {
        // Bild erst jetzt anfordern (siehe data-src im Snippet).
        var img = dialog.querySelector('img[data-src]');
        if (img) {
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
        }

        // Scroll-Lock macht CSS über body:has(...[open]) — kein close-Handling nötig.
        dialog.showModal();
      }
      return;
    }

    if (event.target.closest('[data-ff-fm-close]')) {
      event.target.closest('.ff-fishing-method__dialog').close();
      return;
    }

    // Klick auf den Backdrop: Ziel ist dann das <dialog>-Element selbst.
    if (event.target.classList.contains('ff-fishing-method__dialog')) {
      event.target.close();
    }
  });
})();
